import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../core/Accessor.js";
import { HandleOwnerMixin as s } from "../../core/HandleOwner.js";
import { isSome as t } from "../../core/maybe.js";
import { property as i } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { combinedViewLayerTimeExtentProperty as a } from "./commonProperties.js";
import { isExportDynamic as l } from "./sublayerUtils.js";
import { getLayerFloorFilterClause as n, combineFloorsDefinitionExpression as y } from "../../views/support/floorFilterUtils.js";
var m = {
  visible: "visibleSublayers",
  definitionExpression: "layerDefs",
  labelingInfo: "hasDynamicLayers",
  labelsVisible: "hasDynamicLayers",
  opacity: "hasDynamicLayers",
  minScale: "visibleSublayers",
  maxScale: "visibleSublayers",
  renderer: "hasDynamicLayers",
  source: "hasDynamicLayers"
};

var c = /*#__PURE__*/function (_s) {
  _inherits(c, _s);

  var _super = _createSuper(c);

  function c(e) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e), _this.floors = null, _this.scale = 0;
    return _this;
  }

  _createClass(c, [{
    key: "destroy",
    value: function destroy() {
      this.layer = null;
    }
  }, {
    key: "dynamicLayers",
    get: function get() {
      var _this2 = this;

      if (!this.hasDynamicLayers) return null;
      var e = this.visibleSublayers.map(function (e) {
        var r = n(_this2.floors, e);
        return e.toExportImageJSON(r);
      });
      return e.length ? JSON.stringify(e) : null;
    }
  }, {
    key: "hasDynamicLayers",
    get: function get() {
      return this.layer && l(this.visibleSublayers, this.layer.serviceSublayers, this.layer);
    }
  }, {
    key: "layer",
    set: function set(e) {
      var _this3 = this;

      this._get("layer") !== e && (this._set("layer", e), this.handles.remove("layer"), e && this.handles.add([e.allSublayers.on("change", function () {
        return _this3.notifyChange("visibleSublayers");
      }), e.on("sublayer-update", function (e) {
        return _this3.notifyChange(m[e.propertyName]);
      })], "layer"));
    }
  }, {
    key: "layers",
    get: function get() {
      var e = this.visibleSublayers;
      return e ? e.length ? "show:" + e.map(function (e) {
        return e.id;
      }).join(",") : "show:-1" : null;
    }
  }, {
    key: "layerDefs",
    get: function get() {
      var _this4 = this;

      var e;
      var r = !(null == (e = this.floors) || !e.length),
          s = this.visibleSublayers.filter(function (e) {
        return null != e.definitionExpression || r && null != e.floorInfo;
      });
      return s.length ? JSON.stringify(s.reduce(function (e, r) {
        var s = n(_this4.floors, r),
            i = t(s) ? y(s, r) : r.definitionExpression;
        return e[r.id] = i, e;
      }, {})) : null;
    }
  }, {
    key: "version",
    get: function get() {
      this.commitProperty("layers"), this.commitProperty("layerDefs"), this.commitProperty("dynamicLayers"), this.commitProperty("timeExtent");
      var e = this.layer;
      return e && (e.commitProperty("dpi"), e.commitProperty("imageFormat"), e.commitProperty("imageTransparency"), e.commitProperty("gdbVersion")), (this._get("version") || 0) + 1;
    }
  }, {
    key: "visibleSublayers",
    get: function get() {
      var _this5 = this;

      var e = [];
      if (!this.layer) return e;

      var r = this.layer.sublayers,
          s = function s(r) {
        var t = _this5.scale,
            i = 0 === t,
            o = 0 === r.minScale || t <= r.minScale,
            a = 0 === r.maxScale || t >= r.maxScale;
        r.visible && (i || o && a) && (r.sublayers ? r.sublayers.forEach(s) : e.unshift(r));
      };

      r && r.forEach(s);

      var t = this._get("visibleSublayers");

      return !t || t.length !== e.length || t.some(function (r, s) {
        return e[s] !== r;
      }) ? e : t;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = this.layer;
      var r = {
        dpi: e.dpi,
        format: e.imageFormat,
        transparent: e.imageTransparency,
        gdbVersion: e.gdbVersion || null
      };
      return this.hasDynamicLayers && this.dynamicLayers ? r.dynamicLayers = this.dynamicLayers : r = _objectSpread(_objectSpread({}, r), {}, {
        layers: this.layers,
        layerDefs: this.layerDefs
      }), r;
    }
  }]);

  return c;
}(s(r));

e([i({
  readOnly: !0
})], c.prototype, "dynamicLayers", null), e([i()], c.prototype, "floors", void 0), e([i({
  readOnly: !0
})], c.prototype, "hasDynamicLayers", null), e([i()], c.prototype, "layer", null), e([i({
  readOnly: !0
})], c.prototype, "layers", null), e([i({
  readOnly: !0
})], c.prototype, "layerDefs", null), e([i({
  type: Number
})], c.prototype, "scale", void 0), e([i(a)], c.prototype, "timeExtent", void 0), e([i({
  readOnly: !0
})], c.prototype, "version", null), e([i({
  readOnly: !0
})], c.prototype, "visibleSublayers", null), c = e([o("esri.layers.mixins.ExportImageParameters")], c);
export { c as ExportImageParameters };